/*********************** Custom JS for Boost AI Search & Discovery  ************************/
 componentRegistry.useComponentPlugin("CollectionHeader.HeaderImage", {
      name: "Change image resolution",
      enabled: true,
      apply: () => ({
         props: (props) => {
          props.deviceSizes = [1000]; 
          props.imageSizes = [800];

          return props;
        },
      }),
    });